<template>
	<div class="pin" :class="{ 'is_opened': isVisible }" :style="params.styles" @click.stop="handleClick">
		<transition name="fade">
			<div v-if="isVisible" class="pin__info" :class="pinExpandDirectionClass()">
				<span class="category_name">{{ params.prod_category }}</span>
				<span class="product_name">{{ params.prod_name }}</span>

				<div v-if="buybox.isOpened" class="buybox-container">
					<div class="buybox-container__content">
						<h3>Sklepy internetowe, w&nbsp;których kupisz ten produkt</h3>
						<div v-if="buybox.isLoading" class="loader" style="border-color: transparent #e41429;"></div>
						<ul v-else>
							
							<li v-for="shop in buybox.currentShopsList" v-bind:key="shop.shop_name">
								<a @click.stop :href="shop.product_url" target="_blank" rel="noopener noreferrer">
									<img :src="'https://www.amica.pl/theme/Modern/img/View/product/buybox/' + shop.shop_logo + '.jpg'" alt="">
								</a>
							</li>

							<div v-if="!buybox.currentShopsList.length" class="no-shops">
								Brak danych
							</div>

						</ul>
					</div>
				</div>

				<button v-if="!buybox.isOpened" @click.prevent.stop="openBuybox">
					<svg xmlns="http://www.w3.org/2000/svg" width="16.024" height="16" viewBox="0 0 16.024 16"><path class="a" d="M14,13.2a2.4,2.4,0,1,1-2.264,1.6H8.26a2.4,2.4,0,1,1-4.5-.08A2.4,2.4,0,0,1,4.4,10V3.6H2.8A.8.8,0,0,1,2.8,2H5.2a.8.8,0,0,1,.8.8v.8H17.2a.8.8,0,0,1,.72,1.16l-3.2,6.4a.8.8,0,0,1-.72.44H4.4a.8.8,0,0,0,0,1.6ZM6,10h7.5l2.4-4.8H6Zm0,6.4a.8.8,0,1,0-.8-.8A.8.8,0,0,0,6,16.4Zm8,0a.8.8,0,1,0-.8-.8A.8.8,0,0,0,14,16.4Z" transform="translate(-1.978 -2)"/></svg>
					Kup teraz
				</button>
			</div>
		</transition>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	props: ['params'],
	data () {
		return {
			buybox: {
        isLoading: false,
        isOpened: false,
        currentShopsList: [{"product_url":"https:\/\/go.buybox.click\/bbclick_1123_43469751?p1=sprawdz-cene","shop_name":"mediaexpert.pl","shop_logo":"mediaexpert","cta_case":"sprawd\u017a cen\u0119","original_logo":"https:\/\/buybox.click\/uploads\/campaign\/e67ead91b125d698c9af03dfbcdc3a7b7bda81ff.png"},{"product_url":"https:\/\/go.buybox.click\/bbclick_1123_43512523?p1=sprawdz-cene","shop_name":"Avans.pl","shop_logo":"avans","cta_case":"sprawd\u017a cen\u0119","original_logo":"https:\/\/buybox.click\/uploads\/campaign\/0b45882703d9706340742091e440ec20b72740c6.png"},{"product_url":"https:\/\/go.buybox.click\/bbclick_1123_43504496?p1=sprawdz-cene","shop_name":"Electro.pl","shop_logo":"electro","cta_case":"sprawd\u017a cen\u0119","original_logo":"https:\/\/buybox.click\/uploads\/campaign\/ea3437a74b54c1ffb396bb7f692262a13dae2800.jpeg"},{"product_url":"https:\/\/go.buybox.click\/bbclick_1123_66410399?p1=sprawdz-cene","shop_name":"MyCenter.pl","shop_logo":"mycenter","cta_case":"sprawd\u017a cen\u0119","original_logo":"https:\/\/buybox.click\/uploads\/campaign\/24e94ee6792f3421b47b0d060cf4754ee4c2ca5d.png"}],
      },
		}
	},
	computed: {
		isVisible: function () {
			return this.params.visible
		}
	},
	methods: {
		handleClick: function () {
			let beforeCloseVisibleState = this.params.visible
			this.$emit('closeAllPins')
			this.params.visible = !beforeCloseVisibleState
		},
		openBuybox: function () {
      let cmp = this
			let prodEAN = cmp.params.prod_ean
			cmp.buybox.currentShopsList = []

      if (prodEAN) {
				cmp.buybox.isLoading = true
				cmp.buybox.isOpened = true
        axios.get('https://www.amica.pl/SoapProducts/getOnlineShopsAjax/prodEan:' + prodEAN + '.json').then(r => {
          r.data.forEach(shop => {
            cmp.buybox.currentShopsList.push(shop)
          })
          cmp.buybox.isLoading = false
				})
      }
		},
		pinExpandDirectionClass: function () {
			return 'expand-direction--' + this.params.expand_direction
		}
	}
}
</script>

<style lang="scss" scoped>
	.pin {
		position: absolute;
		width: 60px;
		height: 60px;
		border-radius: 99px;
		background: #e41429;

		-webkit-transition: all .1s ease-in-out;
		-moz-transition: all .1s ease-in-out;
		-o-transition: all .1s ease-in-out;
		transition: all .1s ease-in-out;

		&:before {
			content: "";
			width: 2px;
			height: 30px;
			background: #fff;
			position: absolute;
			top: 50%;
			left: 50%;
		}

		&:after {
			content: "";
			width: 30px;
			height: 2px;
			background: #fff;
			position: absolute;
			top: 50%;
			left: 50%;
		}

		&:after, &:before {
			-webkit-transform: translateX(-50%) translateY(-50%); 
			-moz-transform: translateX(-50%) translateY(-50%); 
			-ms-transform: translateX(-50%) translateY(-50%); 
			-o-transform: translateX(-50%)mtranslateY(-50%); 
			transform: translateX(-50%) translateY(-50%);
		}

		&.is_opened {
			// -moz-transform: rotate(45deg);
			// -webkit-transform: rotate(45deg);
			// -o-transform: rotate(45deg);
			// -ms-transform: rotate(45deg);
			// transform: rotate(45deg);
		}

		@media only screen and (max-width : 1400px) {
			width: 50px;
			height: 50px;
		}

		@media only screen and (max-width : 1150px) {
			height: 40px;
			width: 40px;

			&:before {
				height: 20px;
			}

			&:after {
				width: 20px;
			}
		}

		.pin__info {
			position: absolute;
			top: -2px;
			width: auto;
			min-width: 260px;
			height: auto;
			background: #fff;
			border-radius: 10px;
			padding: 10px;

			-webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
			-moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
			box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);

			&:after {
				content: "";
				width: 12px;
				height: 12px;
				background: #fff;
				position: absolute;
				right: -6px;
				top: 25px;

				-moz-transform: rotate(45deg);
				-webkit-transform: rotate(45deg);
				-o-transform: rotate(45deg);
				-ms-transform: rotate(45deg);
				transform: rotate(45deg);
			}

			&.expand-direction--left {
				right: 75px;
			}

			&.expand-direction--right {
				left: 75px;

				&:after {
					right: initial;
					left: -6px;
				}
			}

			@media only screen and (max-width : 1400px) {
				top: -7px;
			}

			@media only screen and (max-width : 1150px) {
				top: -12px;

				&.expand-direction--left {
					right: 55px;
				}

				&.expand-direction--right {
					left: 55px;
				}
			}

			& > span {
				width: 100%;
				display: inline-block;
			}

			.category_name {
				font-family: "Lato";
				font-size: 14px;
				color: #e41429;
				text-transform: uppercase;
				white-space: nowrap;
			}

			.product_name {
				font-size: 22px;
				text-transform: uppercase;
				line-height: 20px;
				white-space: nowrap;
			}

			& > button {
				border: none;
				width: 100%;
				margin-top: 20px;
				padding: 10px;
				border-radius: 10px;
				color: #fff;
				text-transform: uppercase;
				cursor: pointer;

				background: #e41429;
				background: -moz-linear-gradient(left, #e41429 0%, #ae0b11 100%);
				background: -webkit-linear-gradient(left, #e41429 0%,#ae0b11 100%);
				background: linear-gradient(to right, #e41429 0%,#ae0b11 100%);
				filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e41429', endColorstr='#ae0b11',GradientType=1 );

				&:focus {
					outline: none;
				}

				svg {
					margin-right: 7px;
					margin-top: -4px;

					.a {
						fill: #fff;
					}
				}
			}

			.loader {
				margin-top: 20px;
				margin-bottom: 10px;
			}

		}

		.buybox-container {
			border: 1px #dedede solid;
			margin-top: 10px;
			padding: 10px;
			border-radius: 10px;

			.buybox-container__content {

				h3 {
					font-size: 12px;
					width: calc(100% + 20px);
					text-align: center;
					margin-top: -10px;
					text-transform: uppercase;
					line-height: 16px;
					background: #f7f7f7;
					margin-left: -10px;
					padding: 10px;
					-webkit-border-top-left-radius: 10px;
					-webkit-border-top-right-radius: 10px;
					-moz-border-radius-topleft: 10px;
					-moz-border-radius-topright: 10px;
					border-top-left-radius: 10px;
					border-top-right-radius: 10px;
				}

				ul {
					padding-left: 0px;
					margin-bottom: 0px;
					list-style: none;
					margin-top: 20px;

					-moz-column-count: 2;
					-moz-column-gap: 5px;
					-webkit-column-count: 2;
					-webkit-column-gap: 5px;
					column-count: 2;
					column-gap: 5px;

					li {
						text-align: center;
						margin-bottom: 10px;
						min-height: 35px;
						display: inline-block;
						width: 100%;

						a {
							vertical-align: middle;

							img {
								max-width: 90px;
							}
						}
					}
				}
				
			}

			.no-shops {
				text-align: center;
				width: 200%;
				margin-bottom: 37px;
				font-size: 14px;
			}
		}
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
